export default "__VITE_ASSET__71ZkY5J$__"